import { render } from "./PreviousAccount.vue?vue&type=template&id=1a014b95"
import script from "./PreviousAccount.vue?vue&type=script&lang=js"
export * from "./PreviousAccount.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__